import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

const SkeletonBar: FunctionComponent<{ className?: string }> = ({ className }) => (
	<div
		className={classNames(
			"h-3 rounded-full bg-border-light/70 animate-pulse",
			className ?? "w-full"
		)}
	/>
);

const SkeletonSection: FunctionComponent<{ rows?: number }> = ({ rows = 5 }) => (
	<div className="w-full max-w-5xl border border-border-light rounded-xl bg-brand-white p-5 mb-4">
		<div className="h-5 w-40 rounded bg-border-light/70 animate-pulse mb-4" />
		<div className="flex flex-col gap-3">
			{Array.from({ length: rows }).map((_, idx) => (
				<div key={idx} className="flex flex-row items-center gap-4">
					<div className="h-4 w-36 rounded bg-border-light/70 animate-pulse" />
					<div className="h-6 w-16 rounded-xl bg-border-light/70 animate-pulse" />
					<SkeletonBar className="flex-1" />
					<div className="h-4 w-12 rounded bg-border-light/70 animate-pulse" />
				</div>
			))}
		</div>
	</div>
);

export const AnalyticsSkeleton: FunctionComponent = () => {
	return (
		<div className="flex flex-col gap-0 mt-6">
			<SkeletonSection rows={6} />
			<SkeletonSection rows={3} />
			<SkeletonSection rows={5} />
			<SkeletonSection rows={7} />
		</div>
	);
};
